import styled from "@rentiohq/shared-frontend/dist/components/theme/styled-components";
import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";

// TODO: Move
export const PaymentRequestsWrap = styled.div`
  padding-left: 16px;
  padding-right: 16px;
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    padding-left: 40px;
    padding-right: 40px;
  }
`;

export const Wrap = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 12px 0;
`;

export const LeftWrap = styled.div`
  flex: 1;
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: ${props => props.theme.colors.global1};
`;

export const Address = styled.div`
  font-size: 14px;
  margin-top: 2px;
  font-weight: 500;
  color: ${props => props.theme.colors.global2};
`;

export const Info = styled.div`
  font-size: 14px;
  margin-top: 3px;
  color: ${props => props.theme.colors.global2};
`;
